import { BASE_PATH } from '../../App/constants'

export const GET_AUTHORIZATION_DATA_URL = () => `${BASE_PATH}/api/websocket/authorization`
